import carruselIni1 from "../../../../assets/images/deportes6.jpg";
import carruselIni2 from "../../../../assets/images/deportes2.jpg";
import carruselIni3 from "../../../../assets/images/deportes3.jpg";
import carruselIni4 from "../../../../assets/images/deportes1.jpg";
import carruselIni5 from "../../../../assets/images/deportes5.jpg";
import carruselIni6 from "../../../../assets/images/deportes8.jpg";
import carruselIni7 from "../../../../assets/images/deportes7.jpg";
import carruselIni8 from "../../../../assets/images/deportes4.jpg";
import MenuInteremedio from "../actividades/menuInteremedioActividades";
import TextoDeportes from "./textoDeportes";

import TextoActividades from "../textoActividadesPrimaria";
import "../actividadPages.css";


function deportes() {
  return (
    <div className="activity-page deportes-page">
      <div
        id="myCarousel"
        className="carousel slide activity-modern-carousel"
        data-bs-ride="carousel"
        data-bs-interval="3800"
        data-bs-pause="hover"
      >


        <div className="carousel-indicators">
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2" ></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="3" aria-label="Slide 4" ></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="5" aria-label="Slide 6" ></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="6" aria-label="Slide 7" ></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="7" aria-label="Slide 8" ></button>
        </div>

        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={carruselIni1} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-start p-3" data-aos="fade-up" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1> EDUCACIÓN FÍSICA</h1>
                <p className="opacity-75">
                  Cuerpo en movimiento, mente en acción.
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Leer mas.
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            <img src={carruselIni2} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Deportes</h1>
                <p className="opacity-75" >
                  Cuerpo en movimiento, mente en acción.
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Leer mas
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            <img src={carruselIni3} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-end p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Educación Física </h1>
                <p className="opacity-75">
                  Cuerpo en movimiento, mente en acción.
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Galeria
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={carruselIni4} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-start p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1> Propuestas ExtraCurriculares </h1>
                <p className="opacity-75">
                  Promovemos la excelencia académica, el compromiso y el crecimiento personal de nuestros estudiantes.
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Ver mas
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={carruselIni5} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Propuestas ExtraCurriculares </h1>
                <p className="opacity-75"></p><p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Ver mas
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={carruselIni6} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-end p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Propuestas ExtraCurriculares.</h1>
                <p className="opacity-75">
                  La excelencia académica, el compromiso y el desarrollo personal.                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Ver mas
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={carruselIni7} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-end p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Juntos por un futuro mejor</h1>
                <p className="opacity-75">
                  Un lugar de aprendizaje, de compartir y de respeto..
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Ver mas
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img src={carruselIni8} className="d-block w-100" alt="..." style={{ height: "500px", objectFit: "cover" }} />
            <div className="container">
              <div className="carousel-caption text-end p-3" style={{ background: "rgba(0, 0, 0, 0.3)" }}>
                <h1>Más que un colegio, una comunidad educativa</h1>
                <p className="opacity-75">
                  Una enseñanza de calidad en un entorno afectuoso.
                </p>
                <p>
                  <a className="btn btn-outline-warning btn-lg" href="#contenido-deportes">
                    Ver mas
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>        {/* botones de control */}
          <button className="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>


      </div>
      {/* Menú - completamente afuera del carrusel */}
      <div className="activity-menu-shell">
        <MenuInteremedio />
      </div>

      <div className="activity-content-stack text-center" id="contenido-deportes">
        <TextoDeportes />
        <hr className="my-8 border-t-2 border-gray-300 opacity-50 w-4/5 mx-auto" />

        <TextoActividades />
        <hr className="my-8 border-t-2 border-gray-300 opacity-50 w-4/5 mx-auto" />

      </div>

    </div>
  );

}


export default deportes;
